export const formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 2,
});

export const formatAndRound = (value: number): string => {
	const roundFormatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0,
	});
	return roundFormatter.format(value);
};

export const unformatter = (value: string): number => {
	return Number(value.replace(/[^0-9.-]+/g, ''));
};

export const unformatterToString = (value: string): string => {
	return value.replace(/[^0-9.-]+/g, '');
};
